import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { portalHomeCommands, roleCanOpen } from '../services/portal-access';
import { PortalRole, PortalRoleService } from '../services/portal-role.service';

/**
 * Blocks direct URLs and browser refresh for pages the signed-in portal role cannot use.
 * Backend authorization is unchanged.
 */
@Injectable({ providedIn: 'root' })
export class PortalPageGuard implements CanActivate {
  constructor(
    private portalRoleService: PortalRoleService,
    private router: Router,
  ) {}

  async canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
    const me = await this.portalRoleService.loadMe();
    const allowed = (route.data?.roles || []) as PortalRole[];
    if (roleCanOpen(me?.role, allowed)) {
      return true;
    }
    await this.router.navigate(portalHomeCommands(me?.role));
    return false;
  }
}
